import { ReactComponent as Driver } from './Driver.svg'
import { ReactComponent as Shopper } from './shopping-cart.svg'
import { ReactComponent as Stager } from './Stager.svg'
import { ReactComponent as FullService } from './rocket.svg'
import { ReactComponent as Truck } from './Truck.svg'
import { ReactComponent as CheckCircle } from './CheckCircle.svg'
import { ReactComponent as Image } from './Image.svg'
import { ReactComponent as User } from './User.svg'
import { ReactComponent as Comment } from './Comment.svg'
import { ReactComponent as Info } from './Info.svg'
import { ReactComponent as InfoBlue } from './info_blue.svg'
import { ReactComponent as ArrowLeft } from './arrow_left.svg'
import { ReactComponent as Loader } from './loader.svg'
import { ReactComponent as Calendar } from './calendar.svg'
import { ReactComponent as Clock } from './clock.svg'
import { ReactComponent as Layers } from './layers.svg'
import { ReactComponent as Package } from './package.svg'
import { ReactComponent as XCircle } from './xCircle.svg'
import { ReactComponent as Invoice } from './invoice.svg'
import { ReactComponent as Catalog } from './catalog.svg'
import { ReactComponent as Category } from './category.svg'
import { ReactComponent as Link } from './link.svg'
import { ReactComponent as BlueLine } from './blueLine.svg'
import { ReactComponent as RoutesMenu } from './routesMenu.svg'
import { ReactComponent as FilterStep } from './FilterStep.svg'
import { ReactComponent as PendingStep } from './PendingStep.svg'
import { ReactComponent as DoneStep } from './DoneStep.svg'
import { ReactComponent as SelectStep } from './SelectStep.svg'
import { ReactComponent as ResourcesStep } from './ResourcesStep.svg'
import { ReactComponent as SimulateStep } from './SimulateStep.svg'
import { ReactComponent as Store } from './store.svg'
import { ReactComponent as ChevronRight } from './chevron-right.svg'
import { ReactComponent as Empty } from './empty.svg'
import { ReactComponent as LocationPin } from './LocationPin.svg'
import { ReactComponent as BigLocation } from './BigLocation.svg'
import { ReactComponent as Warning } from './Warning.svg'
import { ReactComponent as ClockYellow } from './ClockYellow.svg'
import { ReactComponent as Stats } from './Stats.svg'
import { ReactComponent as ZonePicking } from './ZonePicking.svg'
import { ReactComponent as Departments } from './Departments.svg'
import { ReactComponent as CheckCircleGreen } from './CheckCircleGreen.svg'
import { ReactComponent as CreditCard } from './CreditCard.svg'
import { ReactComponent as PickingWithPacking } from './PickingWithPacking.svg'
import { ReactComponent as Consolidation } from './Consolidation.svg'
import { ReactComponent as PaymentMethodCash } from './payment_method_cash.svg'
import { ReactComponent as PaymentMethodCreditCard } from './payment_method_credit_card.svg'
import { ReactComponent as PaymentMethodPaymentLink } from './payment_method_payment_link.svg'
import { ReactComponent as PaymentMethodPaymentTerminal } from './payment_method_payment_terminal.svg'
import { ReactComponent as PaymentMethodTransfer } from './payment_method_transfer.svg'
import { ReactComponent as PaymentMethodLoyaltyCard } from './payment_method_loyalty_card.svg'
import { ReactComponent as PaymentStatusChanged } from './payment_status_changed.svg'
import { ReactComponent as PaymentStatusFailed } from './payment_status_failed.svg'
import { ReactComponent as PaymentStatusInProgress } from './payment_status_in_progress.svg'
import { ReactComponent as PaymentStatusPending } from './payment_status_pending.svg'
import { ReactComponent as PaymentStatusReverted } from './payment_status_reverted.svg'
import { ReactComponent as PaymentStatusSuccess } from './payment_status_success.svg'
import { ReactComponent as SlotCalendar } from './slot_calendar.svg'
import { ReactComponent as SlotExpress } from './slot_express.svg'
import { ReactComponent as ClockGray } from './clock_gray.svg'
import { ReactComponent as CheckBlueIcon } from './check_blue_icon.svg'
import { ReactComponent as TrashRed } from './trash_red.svg'
import { ReactComponent as Processing } from './Processing.svg'
import { ReactComponent as Finished } from './Finished.svg'
import { ReactComponent as OnBoard } from './OnBoard.svg'
import { ReactComponent as Cancelled } from './Cancelled.svg'
import { ReactComponent as Reallocated } from './Reallocated.svg'
import { ReactComponent as Rescheduled } from './Rescheduled.svg'
import { ReactComponent as Reset } from './Reset.svg'
import { ReactComponent as Alert } from './alert.svg'
import { ReactComponent as IconLink } from './icon_link.svg'
import { ReactComponent as IconText } from './icon_text.svg'
import { ReactComponent as HamburguerMenu } from './HamburguerMenu.svg'
import { ReactComponent as DownOutLined } from './downOutLined.svg'
import { ReactComponent as ArrowGreeUp } from './arrow-green-up.svg'
import { ReactComponent as ArrowRedDown } from './arrow-red-down.svg'
import { ReactComponent as CheckGreenInvoice } from './check-green-invoice.svg'
import { ReactComponent as EqualsInvoice } from './equals-invoice.svg'
import { ReactComponent as LoadedInvoice } from './loaded-invoice.svg'
import { ReactComponent as WarningRedInvoice } from './warning-red-invoice.svg'
import { ReactComponent as TablePoint } from './TablePoint.svg'
import { ReactComponent as WarningCircleOrange } from './warning-circle-orange.svg'
import { ReactComponent as WarningCircleRed } from './warning-circle-red.svg'
import { ReactComponent as DragDropIcon } from './drag-drop.svg'
import { ReactComponent as ChangeDriverIcon } from './change_driver_icon.svg'
import { ReactComponent as UserDefault } from './user_default.svg'
import { ReactComponent as CalendarCheck } from './CalendarCheck.svg'
import { ReactComponent as CalendarX } from './CalendarX.svg'
import { ReactComponent as CirclesThreePlus } from './CirclesThreePlus.svg'
import { ReactComponent as Moon } from './Moon.svg'
import { ReactComponent as Removed } from './Removed.svg'
import { ReactComponent as MicrosoftExcelLogo } from './MicrosoftExcelLogo.svg'
import { ReactComponent as UploadFile } from './UploadFile.svg'
import { ReactComponent as CirclesFour } from './CirclesFour.svg'
import { ReactComponent as Copy } from './Copy.svg'
import { ReactComponent as PrintRoute } from './print-route.svg'
import { ReactComponent as ReassingDriver } from './reassing-driver.svg'
import { ReactComponent as Zip } from './zip.svg'
import { ReactComponent as VehiclesRouteStep } from './vehicles-route-step.svg'
import { ReactComponent as JobsRouteStep } from './jobs-route-step.svg'
import { ReactComponent as SimulateRouteStep } from './simulate-route-step.svg'
import { ReactComponent as DoneRouteStep } from './done-route-step.svg'
import { ReactComponent as PendingRouteStep } from './pending-route-step.svg'
import { ReactComponent as TruckBlue } from './truck-blue.svg'
import { ReactComponent as VanBlue } from './van-blue.svg'
import { ReactComponent as MotorcycleBlue } from './motorcycle-blue.svg'
import { ReactComponent as BicycleBlue } from './bicycle-blue.svg'
import { ReactComponent as ScooterBlue } from './scooter-blue.svg'
import { ReactComponent as DroneBlue } from './drone-blue.svg'
import { ReactComponent as WalkBlue } from './walk-blue.svg'
import { ReactComponent as CarBlue } from './car-blue.svg'
import { ReactComponent as VehiclesEmpty } from './vehicles-empty.svg'
import { ReactComponent as TruckGray } from './truck-gray.svg'
import { ReactComponent as VanGray } from './van-gray.svg'
import { ReactComponent as MotorcycleGray } from './motorcycle-gray.svg'
import { ReactComponent as BicycleGray } from './bicycle-gray.svg'
import { ReactComponent as ScooterGray } from './scooter-gray.svg'
import { ReactComponent as DroneGray } from './drone-gray.svg'
import { ReactComponent as WalkGray } from './walk-gray.svg'
import { ReactComponent as CarGray } from './car-gray.svg'
import { ReactComponent as TruckGreen } from './truck-green.svg'
import { ReactComponent as VanGreen } from './van-green.svg'
import { ReactComponent as MotorcycleGreen } from './motorcycle-green.svg'
import { ReactComponent as BicycleGreen } from './bicycle-green.svg'
import { ReactComponent as ScooterGreen } from './scooter-green.svg'
import { ReactComponent as DroneGreen } from './drone-green.svg'
import { ReactComponent as WalkGreen } from './walk-green.svg'
import { ReactComponent as CarGreen } from './car-green.svg'
import { ReactComponent as TaskStatusCreate } from './task-status-create.svg'
import { ReactComponent as TaskStatusCashPayment } from './task-status-cash-payment.svg'
import { ReactComponent as TaskStatusCollecting } from './task-status-collecting.svg'
import { ReactComponent as TaskStatusInTransfer } from './task-status-in-transfer.svg'
import { ReactComponent as TaskStatusInPackaging } from './task-status-in-packaging.svg'
import { ReactComponent as TaskStatusPacked } from './task-status-packed.svg'
import { ReactComponent as SimulateRouteLoading } from './simulate-route-loading.svg'
import { ReactComponent as RoutedOrders } from './routed-orders.svg'
import { ReactComponent as VehiclesWithRoute } from './vehicles-with-route.svg'
import { ReactComponent as LoadingCapacity } from './loading-capacity.svg'
import { ReactComponent as ReloadBlue } from './reload-blue.svg'
import { ReactComponent as WarningYellow } from './warning-yellow.svg'
import { ReactComponent as Edit } from './edit.svg'
import { ReactComponent as Settings } from './settings.svg'
import { ReactComponent as Dots } from './dots.svg'
import { ReactComponent as Lock } from './lock.svg'
import { ReactComponent as Crown } from './crown.svg'
import { ReactComponent as Clipboard } from './clipboard.svg'
import { ReactComponent as SquaresFour } from './squares-four.svg'
import { ReactComponent as Headset } from './headset.svg'
import { ReactComponent as Eye } from './eye.svg'
import { ReactComponent as Phone } from './phone.svg'
import { ReactComponent as Identification } from './identification.svg'
import { ReactComponent as Sparkle } from './sparkle.svg'
import { ReactComponent as MinimumOccupancyBlue } from './minimum_occupancy_blue.svg'
import { ReactComponent as TruckVehicle } from './truck-vehicle.svg'
import { ReactComponent as EssentialProductRed } from './essential-product-red.svg'
import { ReactComponent as ExternalContactWithClientPurple } from './external-contact-with-client-purple.svg'
import { ReactComponent as NewItemGreen } from './new-item-green.svg'
import { ReactComponent as NoReplacementOrange } from './no-replacement_orange.svg'
import { ReactComponent as ReplacementByClientBlue } from './replacement-by-client-blue.svg'
import { ReactComponent as ResourceChooseReplacementGreen } from './resource-choose-replacement-green.svg'
import { ReactComponent as ResourceSuggestsReplacementPink } from './resource-suggests-replacement-pink.svg'
import { ReactComponent as ArrowReplaceItem } from './arrow-replace-item.svg'
import { ReactComponent as Balance } from './balance.svg'

import { Path } from '@phosphor-icons/react'

const Icons = (props) => {
  const { iconName, className, onClick, style } = props
  const commonProps = {
    className,
    onClick,
    style
  }
  const icons = {
    Driver: <Driver {...commonProps} />,
    Shopper: <Shopper {...commonProps} />,
    Stager: <Stager {...commonProps} />,
    FullService: <FullService {...commonProps} />,
    Truck: <Truck {...commonProps} />,
    CheckCircle: <CheckCircle {...commonProps} />,
    Image: <Image {...commonProps} />,
    User: <User {...commonProps} />,
    Comment: <Comment {...commonProps} />,
    Info: <Info {...commonProps} />,
    InfoBlue: <InfoBlue {...commonProps} />,
    ArrowLeft: <ArrowLeft {...commonProps} />,
    Loader: <Loader {...commonProps} />,
    Calendar: <Calendar {...commonProps} />,
    Clock: <Clock {...commonProps} />,
    Layers: <Layers {...commonProps} />,
    Package: <Package {...commonProps} />,
    XCircle: <XCircle {...commonProps} />,
    Invoice: <Invoice {...commonProps} />,
    Catalog: <Catalog {...commonProps} />,
    Link: <Link {...commonProps} />,
    Category: <Category {...commonProps} />,
    BlueLine: <BlueLine {...commonProps} />,
    RoutesMenu: <RoutesMenu {...commonProps} />,
    FilterStep: <FilterStep {...commonProps} />,
    PendingStep: <PendingStep {...commonProps} />,
    DoneStep: <DoneStep {...commonProps} />,
    SelectStep: <SelectStep {...commonProps} />,
    ResourcesStep: <ResourcesStep {...commonProps} />,
    SimulateStep: <SimulateStep {...commonProps} />,
    Store: <Store {...commonProps} />,
    ChevronRight: <ChevronRight {...commonProps} />,
    Empty: <Empty {...commonProps} />,
    LocationPin: <LocationPin {...commonProps} />,
    BigLocation: <BigLocation {...commonProps} />,
    Warning: <Warning {...commonProps} />,
    ClockYellow: <ClockYellow {...commonProps} />,
    Stats: <Stats {...commonProps} />,
    ZonePicking: <ZonePicking {...commonProps} />,
    Departments: <Departments {...commonProps} />,
    CheckCircleGreen: <CheckCircleGreen {...commonProps} />,
    CreditCard: <CreditCard {...commonProps} />,
    PickingWithPacking: <PickingWithPacking {...commonProps} />,
    Consolidation: <Consolidation {...commonProps} />,
    PaymentMethodCash: <PaymentMethodCash {...commonProps} />,
    PaymentMethodCreditCard: <PaymentMethodCreditCard {...commonProps} />,
    PaymentMethodPaymentLink: <PaymentMethodPaymentLink {...commonProps} />,
    PaymentMethodPaymentTerminal: <PaymentMethodPaymentTerminal {...commonProps} />,
    PaymentMethodTransfer: <PaymentMethodTransfer {...commonProps} />,
    PaymentMethodLoyaltyCard: <PaymentMethodLoyaltyCard {...commonProps} />,
    PaymentStatusChanged: <PaymentStatusChanged {...commonProps} />,
    PaymentStatusSuccess: <PaymentStatusSuccess {...commonProps} />,
    PaymentStatusFailed: <PaymentStatusFailed {...commonProps} />,
    PaymentStatusInProgress: <PaymentStatusInProgress {...commonProps} />,
    PaymentStatusPending: <PaymentStatusPending {...commonProps} />,
    PaymentStatusReverted: <PaymentStatusReverted {...commonProps} />,
    SlotCalendar: <SlotCalendar {...commonProps} />,
    SlotExpress: <SlotExpress {...commonProps} />,
    ClockGray: <ClockGray {...commonProps} />,
    CheckBlueIcon: <CheckBlueIcon {...commonProps} />,
    TrashRed: <TrashRed {...commonProps} />,
    Processing: <Processing {...commonProps} />,
    OnBoard: <OnBoard {...commonProps} />,
    Cancelled: <Cancelled {...commonProps} />,
    Finished: <Finished {...commonProps} />,
    Reallocated: <Reallocated {...commonProps} />,
    Rescheduled: <Rescheduled {...commonProps} />,
    Reset: <Reset {...commonProps} />,
    Alert: <Alert {...commonProps} />,
    IconLink: <IconLink {...commonProps} />,
    IconText: <IconText {...commonProps} />,
    HamburguerMenu: <HamburguerMenu {...commonProps} />,
    DownOutLined: <DownOutLined {...commonProps} />,
    ArrowGreeUp: <ArrowGreeUp {...commonProps} />,
    ArrowRedDown: <ArrowRedDown {...commonProps} />,
    CheckGreenInvoice: <CheckGreenInvoice {...commonProps} />,
    EqualsInvoice: <EqualsInvoice {...commonProps} />,
    LoadedInvoice: <LoadedInvoice {...commonProps} />,
    WarningRedInvoice: <WarningRedInvoice {...commonProps} />,
    TablePoint: <TablePoint {...commonProps} />,
    WarningCircleOrange: <WarningCircleOrange {...commonProps} />,
    WarningCircleRed: <WarningCircleRed {...commonProps} />,
    DragDropIcon: <DragDropIcon {...commonProps} />,
    ChangeDriverIcon: <ChangeDriverIcon {...commonProps} />,
    UserDefault: <UserDefault {...commonProps} />,
    CalendarCheck: <CalendarCheck {...commonProps} />,
    CalendarX: <CalendarX {...commonProps} />,
    CirclesThreePlus: <CirclesThreePlus {...commonProps} />,
    Moon: <Moon {...commonProps} />,
    Removed: <Removed {...commonProps} />,
    MicrosoftExcelLogo: <MicrosoftExcelLogo {...commonProps} />,
    UploadFile: <UploadFile {...commonProps} />,
    CirclesFour: <CirclesFour {...commonProps} />,
    Copy: <Copy {...commonProps} />,
    PrintRoute: <PrintRoute {...commonProps} />,
    ReassingDriver: <ReassingDriver {...commonProps} />,
    Zip: <Zip {...commonProps} />,
    VehiclesRouteStep: <VehiclesRouteStep {...commonProps} />,
    JobsRouteStep: <JobsRouteStep {...commonProps} />,
    SimulateRouteStep: <SimulateRouteStep {...commonProps} />,
    DoneRouteStep: <DoneRouteStep {...commonProps} />,
    PendingRouteStep: <PendingRouteStep {...commonProps} />,
    TruckBlue: <TruckBlue {...commonProps} />,
    VanBlue: <VanBlue {...commonProps} />,
    MotorcycleBlue: <MotorcycleBlue {...commonProps} />,
    BicycleBlue: <BicycleBlue {...commonProps} />,
    ScooterBlue: <ScooterBlue {...commonProps} />,
    DroneBlue: <DroneBlue {...commonProps} />,
    WalkBlue: <WalkBlue {...commonProps} />,
    CarBlue: <CarBlue {...commonProps} />,
    VehiclesEmpty: <VehiclesEmpty {...commonProps} />,
    TruckGray: <TruckGray {...commonProps} />,
    VanGray: <VanGray {...commonProps} />,
    MotorcycleGray: <MotorcycleGray {...commonProps} />,
    BicycleGray: <BicycleGray {...commonProps} />,
    ScooterGray: <ScooterGray {...commonProps} />,
    DroneGray: <DroneGray {...commonProps} />,
    WalkGray: <WalkGray {...commonProps} />,
    CarGray: <CarGray {...commonProps} />,
    TruckGreen: <TruckGreen {...commonProps} />,
    VanGreen: <VanGreen {...commonProps} />,
    MotorcycleGreen: <MotorcycleGreen {...commonProps} />,
    BicycleGreen: <BicycleGreen {...commonProps} />,
    ScooterGreen: <ScooterGreen {...commonProps} />,
    DroneGreen: <DroneGreen {...commonProps} />,
    WalkGreen: <WalkGreen {...commonProps} />,
    CarGreen: <CarGreen {...commonProps} />,
    TaskStatusCreate: <TaskStatusCreate {...commonProps} />,
    TaskStatusCashPayment: <TaskStatusCashPayment {...commonProps} />,
    TaskStatusCollecting: <TaskStatusCollecting {...commonProps} />,
    TaskStatusInTransfer: <TaskStatusInTransfer {...commonProps} />,
    TaskStatusInPackaging: <TaskStatusInPackaging {...commonProps} />,
    TaskStatusPacked: <TaskStatusPacked {...commonProps} />,
    SimulateRouteLoading: <SimulateRouteLoading {...commonProps} />,
    RoutedOrders: <RoutedOrders {...commonProps} />,
    VehiclesWithRoute: <VehiclesWithRoute {...commonProps} />,
    LoadingCapacity: <LoadingCapacity {...commonProps} />,
    ReloadBlue: <ReloadBlue {...commonProps} />,
    WarningYellow: <WarningYellow {...commonProps} />,
    Edit: <Edit {...commonProps} />,
    Settings: <Settings {...commonProps} />,
    Dots: <Dots {...commonProps} />,
    Lock: <Lock {...commonProps} />,
    Crown: <Crown {...commonProps} />,
    Clipboard: <Clipboard {...commonProps} />,
    SquaresFour: <SquaresFour {...commonProps} />,
    Headset: <Headset {...commonProps} />,
    Eye: <Eye {...commonProps} />,
    Phone: <Phone {...commonProps} />,
    Identification: <Identification {...commonProps} />,
    Sparkle: <Sparkle {...commonProps} />,
    MinimumOccupancyBlue: <MinimumOccupancyBlue {...commonProps} />,
    TruckVehicle: <TruckVehicle {...commonProps} />,
    EssentialProductRed: <EssentialProductRed {...commonProps} />,
    ExternalContactWithClientPurple: <ExternalContactWithClientPurple {...commonProps} />,
    NewItemGreen: <NewItemGreen {...commonProps} />,
    NoReplacementOrange: <NoReplacementOrange {...commonProps} />,
    ReplacementByClientBlue: <ReplacementByClientBlue {...commonProps} />,
    ResourceChooseReplacementGreen: <ResourceChooseReplacementGreen {...commonProps} />,
    ResourceSuggestsReplacementPink: <ResourceSuggestsReplacementPink {...commonProps} />,
    ArrowReplaceItem: <ArrowReplaceItem {...commonProps} />,
    Path: <Path {...commonProps} />,
    Balance: <Balance {...commonProps} />
  }
  return icons[iconName]
}

export default Icons
